import request from "../../../../helpers/request"
import { IGetConfigPtMonDigital } from "./types"

export const getConfigPtMonDigital = async ({ adrModulo, idCentral, idEntrada }: IGetConfigPtMonDigital) => {
  const url = `${process.env.REACT_APP_API}/MonDigital/GetByEntrada?idCentral=${idCentral}&adrModulo=${adrModulo}&idEntrada=${idEntrada}`
  const result = await request({ url })
  return result.data
}